import dayjs from 'dayjs';
import { isEmpty as _isEmpty } from 'lodash';
import axios from 'axios';

const cacheData = new Map();

export const fetchLowFareAPI = async (origin, destination, departureDate, isPayPointRef, endpointUrl, isOneWay) => {
	const cacheKey = `${origin}|${destination}${departureDate ? `|${dayjs(departureDate).format('DDMMYY')}` : '' }${ isOneWay ? '|OneWay' : '|Return'}`;
	
	if (cacheData.get(cacheKey)) {
		return cacheData.get(cacheKey);
	}
	
	try {
		const responseData = await axios.get(endpointUrl, {
			params: {
				ori: origin,
				des: destination,
			},
		});

		if (responseData.status === 200) {
			cacheData.set(cacheKey, responseData.data);
			return responseData.data;
		}

		throw new Error(responseData);

	} catch (err) {
		console.warn(`useEnrichLowFarePrice.js fetchLowFareAPI API error`, err);
		throw new Error(err);
	}
	
};

export function useEnrichLowFarePriceList ({ originRef, destinationRef, departureDateRef, paymentTypeRef, endpointUrl, isOneWayRef } = {}) {
	const priceData = ref(null);
	const currency = ref('');
	const returnTypeDepartureDateAndFare = ref(null);

	const unwatch = watch([
		originRef,
		destinationRef,
		departureDateRef,
		paymentTypeRef,
		isOneWayRef,
	].filter(Boolean), async () => {
		
		if (!originRef.value?.code || !destinationRef.value?.code) return {};
		
		let apiData = null;
		
		try {
			apiData = await fetchLowFareAPI(originRef.value.code, destinationRef.value.code, departureDateRef.value, paymentTypeRef?.value, endpointUrl, isOneWayRef.value);
		} catch (e) {
			return e;
		}

		if (!_isEmpty(apiData) && apiData.results) {
			const processedPriceData = processPriceData(apiData.results);
			priceData.value = processedPriceData;
			currency.value = apiData.currency || '';

			// For calendar API, we don't have returnDetail structure
			if (departureDateRef.value) {
				returnTypeDepartureDateAndFare.value = apiData;
			}
		} else {
			priceData.value = null;
			currency.value = '';
			returnTypeDepartureDateAndFare.value = null;
		}
		
	});
	
	const cleanUp = () => {
		unwatch();
	};

	return {
		priceData,
		currency,
		returnTypeDepartureDateAndFare,
		cleanUp,
	};
}

function processPriceData (results) {
	if (!Array.isArray(results) || _isEmpty(results)) return {};

	let data = {};

	results.forEach(({ date, fareAmount, flag }) => {
		// Skip if no fare amount or if flag indicates unavailable
		if (!fareAmount || fareAmount === '0.00' || flag === 'N') return;
		
		// Parse the date format from calendar API (e.g., "2025-08-27")
		const [year, month, day] = date.split('-');
		
		// Return "Available" instead of the actual fare amount
		data[`${year}-${month}-${day}`] = 'Available';
	});

	return data;
}